import { CircularProgress, withStyles } from "@material-ui/core";
import React, { useEffect, useReducer, useState } from "react";
import moment from "moment";
import Table from "../../../../../components/Table/Table";
import MensagemListaVazia from "../../../../../components/Mensagem/MensagemListaVazia";
import { columns } from "../constants";
import {
  findOrcamentoById,
  linkEmitirNotaFiscal,
  updateStatusProcedimento,
  verificaPossuiNotaFiscal,
  verificaUtilizaRepasseAutomaticoProcedimentoOrcamento,
} from "../../../../../services/ProcedimentoOdontologicoSujeitoAtencaoService";
import { findByUnidadeLogadaConfiguracaoUnidade } from "../../../../../services/ConfiguracoesUnidadeService";
import AlertaCancelamento from "./AlertaCancelamento";
import Scroll from "../../../../../components/InfiniteScroll/Scroll";
import ModalConfirmacao from "../../../../../components/Modal/ModalConfirmacao/ModalConfirmacao";
import { TextFieldSearch } from "../../../../../components/TextField";
import { findAllProfissionalSaudeComAgenda } from "../../../../../services/ProfissionalSaudeService";
import InputDateForm from "../../../../../components/Input/InputDateForm";

const ProcedimentoOdontologicoSujeitoAtencaoTable = ({
  classes,
  procedimentosOdontologico,
  loading,
  setProcedimentoOdontologicoSelected,
  setOrcamentoSelected,
  setOpenModal,
  loadProcedimentosOdontologico,
  setNotification,
  procedimentoOdontologicoSelected,
}) => {
  const [openAlertCancelamento, toggleModalConfirmacao] = useReducer(
    (state) => !state,
    false
  );
  const [orcamentoToCancel, setOrcamentoToCancel] = useState(null);
  const [motivoCancelamento, setMotivoCancelamento] = useState("");
  const [openModalNotaFiscal, toggleModalNotaFiscal] = useReducer(
    (state) => !state,
    false
  );
  const [
    utilizaRepasseAutomaticoProcedimentoOrcamento,
    setUtilizaRepasseAutomaticoProcedimentoOrcamento,
  ] = useState(false);
  const [
    permiteFinalizacaoSemFaturamento,
    setPermiteFinalizacaoSemFaturamento,
  ] = useState(false);
  const [
    profissionalSaudeExecutanteSelected,
    setProfissionalSaudeExecutanteSelected,
  ] = useState(null);
  const [operacao,setOperacao]=useState(null)
  const [dataCompetencia, setDataCompetencia] = useState(moment())

  useEffect(() => {
    getUtilizaRepasseAutomaticoProcedimentoOrcamento();
    getPermiteFinalizacaoSemFaturamento();
  }, []);

  useEffect(() => {
    if (procedimentoOdontologicoSelected) {
      setProfissionalSaudeExecutanteSelected(procedimentoOdontologicoSelected?.orcamentoAtual?.profissionalSaude?.id);
    }
  }, [procedimentoOdontologicoSelected]);

  const getUtilizaRepasseAutomaticoProcedimentoOrcamento = async () => {
    const response = await verificaUtilizaRepasseAutomaticoProcedimentoOrcamento();
    setUtilizaRepasseAutomaticoProcedimentoOrcamento(response.utilizaRepasseAutomaticoProcedimentoOrcamento);
  };

  const getPermiteFinalizacaoSemFaturamento = async () => {
    try {
      const response = await findByUnidadeLogadaConfiguracaoUnidade();
      const config = response.data.data.findByUnidadeLogadaConfiguracaoUnidade;
      setPermiteFinalizacaoSemFaturamento(!!config?.permiteFinalizarProcedimentoOdontologicoSemFaturamento);
    } catch (error) {
      console.error(error);
    }
  };

  const getDadosRow = async (value) => {
    const { orcamentoAtual } = value || {};

    const response = await findOrcamentoById(orcamentoAtual?.id);
    setOrcamentoSelected(response);
    setProcedimentoOdontologicoSelected(value);
    setOpenModal(true);
  };

  const handleUpdateOrcamento = async (e, status) => {
    try {
      const variables = {
        procedimentosOdontologicoId: [e.id],
        motivo: motivoCancelamento,
        status: status,
      };

      await updateStatusProcedimento(variables);

      loadProcedimentosOdontologico({ isClearable: true });

      setNotification({
        open: true,
        message: "Salvo com sucesso!",
        type: "success",
      });
    } catch (e) {
      setNotification({
        open: true,
        message: "Ocorreu um erro!",
        type: "error",
      });
      console.error("Error", e);
    }
  };

  const handleConfirmCancelProcedimento = () => {
    handleUpdateOrcamento(orcamentoToCancel, "CANCELAR_EXECUCAO");
    toggleModalConfirmacao();
    setOrcamentoToCancel(null);
    setMotivoCancelamento("");
  };

  const handleCancelMotivoCancelamento = () => {
    toggleModalConfirmacao();
    setOrcamentoToCancel(null);
  };

  const handleFinalizar = async (e) => {
    handleUpdateOrcamento(e, "FINALIZADO");
    toggleModalNotaFiscal();
    setProcedimentoOdontologicoSelected(e);
    setOperacao("FINALIZAR")
  };

const handleGerarRepasse = async (e)=>{
  setOperacao("GERAR_REPASSE")
  setProcedimentoOdontologicoSelected(e);
  toggleModalNotaFiscal();
}

  const loadProfissionalSaude = async (search, loadedOptions, { page }) => {
    const response = await findAllProfissionalSaudeComAgenda({
      search,
      ativo: true,
      pageableDTO: {
        sortDir: "ASC",
        sortField: "nome",
        pageNumber: page,
        pageSize: 20,
      },
    });

    const { content, last } = response;

    if (content) {
      return {
        options: content,
        hasMore: !last,
        additional: {
          page: page + 1,
        },
      };
    }
  };

  const handleEmitirNotaFiscal = async (gerarNota=true) => {
    try {
      const { orcamentoAtual, id } = procedimentoOdontologicoSelected || {};
  
      const orcamentoProcedimento = orcamentoAtual?.orcamentoProcedimentos.find(item => {
        return item.procedimentoOdontologico?.id === id
      })
  
      const linkAzulControle = await linkEmitirNotaFiscal({
        orcamentoProcedimentoId: orcamentoProcedimento?.id,
        ...(profissionalSaudeExecutanteSelected?.id && {profissionalSaudeId: profissionalSaudeExecutanteSelected.id}),
        gerarNota: gerarNota,
        ...(!gerarNota && dataCompetencia && {dataCompetencia: moment(dataCompetencia).format("YYYY-MM-DD")}),
      });
  
      if(!gerarNota && linkAzulControle === null) {
        loadProcedimentosOdontologico({ isClearable: true });

        setNotification({
          open: true,
          message: "Repasse realizado com sucesso!",
          type: "success",
        });
    
        return;
      };
        
      window.open(linkAzulControle);
  
      loadProcedimentosOdontologico({ isClearable: true });
      toggleModalNotaFiscal();

    } catch(error) {
      setNotification({
        open: true,
        message: error,
        type: "error",
      });
    } 
  };

  const handleVerificaEmiteNotaFiscal = async(e) => {
    setOperacao(null);
    const { agendamento, orcamentoAtual, id } = e || {};
    
    const orcamentoProcedimento = orcamentoAtual?.orcamentoProcedimentos.find(item => {
      return item.procedimentoOdontologico?.id === id
    })

    const possuiNotaFiscal = await verificaPossuiNotaFiscal({ orcamentoProcedimentoId: orcamentoProcedimento?.id });

    if(!possuiNotaFiscal) {
      toggleModalNotaFiscal();

      agendamento?.id && setProfissionalSaudeExecutanteSelected(agendamento.profissionalSaude)
    }

    setProcedimentoOdontologicoSelected(e);
  }

  return (
    <div className={classes.container}>
      <div className={classes.tableContainer}>
        <Scroll className={classes.scrollContainer}>
          <Table
            dados={procedimentosOdontologico}
            columns={columns({
              functions: {
                handleFinalizar: handleFinalizar,
                handleAprovar: (e) =>
                  handleUpdateOrcamento(e, "APROVADO"),
                 handleGerarRepasse: (e)=> handleGerarRepasse(e, "GERAR_REPASSE"),
                handleCancelar: (e) => {
                  toggleModalConfirmacao();
                  setOrcamentoToCancel(e);
                },
                handleEmAndamento: (e) =>
                  handleUpdateOrcamento(e, "EM_ANDAMENTO"),
                handleNotaFiscal: (e) => 
                  handleVerificaEmiteNotaFiscal(e),
              },
              permiteFinalizacaoSemFaturamento,
            })}
            clickable
            getDadosRow={getDadosRow}
          />
        </Scroll>
      </div>
      {loading && (
        <div className={classes.wrapperLoading}>
          <CircularProgress />
        </div>
      )}
      {!loading && !procedimentosOdontologico.length && <MensagemListaVazia />}
      {openAlertCancelamento && (
        <AlertaCancelamento
          open={openAlertCancelamento}
          handleCancelar={handleCancelMotivoCancelamento}
          valueInput={motivoCancelamento}
          onChangeMotivo={setMotivoCancelamento}
          handleContinuar={handleConfirmCancelProcedimento}
        />
      )}
      {openModalNotaFiscal && (
        <ModalConfirmacao
          open={openModalNotaFiscal}
          onClose={() => toggleModalNotaFiscal()}
          title={operacao ==="GERAR_REPASSE"? "Gerar repasse":"Emissão de nota fiscal"}
          buttons={{
            labelPrimaryButton: "Não",
            handlePrimaryButton: () => toggleModalNotaFiscal(),
            idPrimaryButton: "pac-pod-btn-nao",
            labelSecondButton: "Sim",
            handleSecondButton: () => handleEmitirNotaFiscal(operacao !== "GERAR_REPASSE"),
            idSecondButton: "pac-pod-btn-sim",
          }}
          classes={{
            paperAlert: classes.paperAlert,
          }}
        >
          <div>
            {utilizaRepasseAutomaticoProcedimentoOrcamento && (
              <div>
                <p className={classes.descricaoRepasse}>
                  Para realizar o repasse automático, informe o profissional de
                  saude executante:
                </p>
                <TextFieldSearch
                  id="pac-pod-txt-pro"
                  classNotched={classes.notchedOutline}
                  classInput={classes.inputTextField}
                  placeholder={"Selecione"}
                  onChange={(e) => setProfissionalSaudeExecutanteSelected(e)}
                  value={profissionalSaudeExecutanteSelected}
                  menuPlacement={"auto"}
                  isClearable
                  getOptionLabel={(option) => option.nome}
                  getOptionValue={(option) => option.id}
                  withPaginate
                  loadOptions={loadProfissionalSaude}
                  debounceTimeout={300}
                  additional={{
                    page: 0,
                  }}
                />
                <div className={classes.divider} />
              </div>
            )}
            {operacao === "GERAR_REPASSE" && (
              <div>
                <p className={classes.descricaoRepasse}>Data de competência:</p>
                <InputDateForm
                  value={dataCompetencia}
                  onChange={(date) => setDataCompetencia(date)}
                />
              </div>
            )}
            {operacao !== "GERAR_REPASSE" && (
            <p className={classes.text}>Deseja gerar a nota fiscal?</p>)}
          </div>
        </ModalConfirmacao>
      )}
    </div>
  );
};

const style = {
  container: {
    gridArea: "content",
    display: "grid",
    gridTemplateRows: "auto 1fr",
    gridTemplateAreas: ` 
      "search"
      "filter" 
      "lista"
    `,
    overflow: "hidden",
    position: "relative",
    "& thead th": {
      textAlign: "left",
      top: 0,
      position: "sticky",
    },
  },
  wrapperLoading: {
    width: "100%",
    justifyContent: "center",
    display: "flex",
  },
  tableContainer: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    backgroundColor: "#F5F5F5",
    height: "calc(100vh - 250px)",
    gap: "16px",
    "&> div": {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "100%",
      overflow: "auto",
      borderRadius: "16px",
      border: "solid 1px rgba(0, 0, 0, 0.1)",
      backgroundColor: "#FFF",
    },
  },
  descricaoRepasse: {
    color: "#585858",
    margin: "16px 0",
    fontSize: "16px",
  },
  divider: {
    border: "1px solid rgba(0, 0, 0, 0.1)",
    marginTop: "16px",
  },
  text: {
    fontWeight: 500,
    fontSize: "16px",
  },
  paperAlert: {
    maxWidth: "443px",
    padding: "32px",
  },
};

export default withStyles(style)(ProcedimentoOdontologicoSujeitoAtencaoTable);
